export default "__VITE_ASSET__BRgtVobl__"